export class BaseFetchOptionsFormatter {
    constructor(settings) {
        this.format = (_request, signal) => (Object.assign(Object.assign({}, this.getBaseOptions(signal)), this.options));
        this.getConsumerMetadata = (consumerMetadata) => (Object.assign({ clientName: "web", clientPage: "unknown", clientFeature: "unknown", clientVersion: "unknown", widgetName: "n/a", widgetVersion: "n/a" }, consumerMetadata));
        this.consumerMetadata = this.getConsumerMetadata(settings.consumerMetadata || {});
    }
    getBaseOptions(signal) {
        return {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json charset=utf-8",
                "X-Client-Name": this.consumerMetadata.clientName,
                "X-Client-Version": this.consumerMetadata.clientVersion,
                "X-Client-Feature": this.consumerMetadata.clientFeature,
                "X-Client-Page": this.consumerMetadata.clientPage,
                "X-Client-Widget-Name": this.consumerMetadata.widgetName,
                "X-Client-Widget-Version": this.consumerMetadata.widgetVersion,
            }),
            signal,
        };
    }
}
//# sourceMappingURL=BaseFetchOptionsFormatter.js.map